import { connect } from 'react-redux';
import View from './NotesPopupView';
import {
  isOpen as isOpenSelector,
  isLoading as isLoadingSelector,
  insuranceName as insuranceNameSelector,
  name as nameSelector,
  description as descriptionSelector,
  shouldDrawDescriptionLabel as shouldDrawDescriptionLabelSelector,
} from './NotesPopupSelector';
import { setOpen, setDescription, saveDescription } from './NotesPopupActions';

const mapStateToProps = (state, ownProps) => {
  return {
    isLoading: isLoadingSelector(state, ownProps),
    isOpen: isOpenSelector(state, ownProps),
    insuranceName: insuranceNameSelector(state, ownProps),
    name: nameSelector(state, ownProps),
    description: descriptionSelector(state, ownProps),
    shouldDrawDescriptionLabel: shouldDrawDescriptionLabelSelector(state, ownProps),
  };
};

const mapDispatchToProps = dispatch => ({
  onDismiss: (clientId, goalId, subgoalId) => () => {
    dispatch(setOpen(clientId, goalId, subgoalId, false));
  },
  onSetDescription: (clientId, goalId, subgoalId) => event => {
    event.stopPropagation();
    event.preventDefault();
    dispatch(setDescription(clientId, goalId, subgoalId, event.target.value));
  },
  onSave: (clientId, goalId, subgoalId, name, description) => event => {
    event.stopPropagation();
    event.preventDefault();
    dispatch(saveDescription(clientId, goalId, subgoalId, name, description));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
